import React from 'react';
export function BenefitsSection() {
  const benefits = [{
    emoji: '⚡',
    title: 'Freedom from Mental Load',
    desc: 'Open the volume, pick the theme, and coach. Your planning is already done for the entire year.'
  }, {
    emoji: '👑',
    title: 'Authority and Confidence',
    desc: "Arrive at the court as an expert. With validated sessions, you'll always have the right word to guide your players."
  }, {
    emoji: '🌿',
    title: 'Real Team Progression',
    desc: 'Validated sequences that respect modern volleyball principles for visible results come tournament day.'
  }, {
    emoji: '😌',
    title: 'Zero Transition Stress',
    desc: 'Master the flow between drills for a fluid practice that will impress your athletic director, parents, and players.'
  }];
  return <section className="bg-white py-20 px-4 sm:px-6 lg:px-8" data-id="element-15">
      <div className="max-w-5xl mx-auto" data-id="element-16">
        <div className="text-center mb-12" data-id="element-17">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-[10px] px-3 py-1 mb-6 inline-block uppercase tracking-[0.2em] border border-pilates-sage/20" data-id="element-18">
            WHAT WILL CHANGE
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight mb-4 tracking-tight" data-id="element-19">
            The real benefits starting from{' '}
            <span className="italic text-pilates-rose" data-id="element-20">Week 1</span>
          </h2>
          <p className="text-pilates-slate text-lg max-w-2xl mx-auto" data-id="element-21">
            What changes immediately:
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-22">
          {benefits.map((b, idx) => {
          const roman = ['I', 'II', 'III', 'IV'][idx];
          return <div key={idx} className="bg-pilates-cream rounded-lg p-7 border border-pilates-slate/10 hover:shadow-md hover:-translate-y-1 transition-all relative" data-id="element-23">
                <div className="absolute top-6 right-6 w-8 h-8 bg-pilates-blue-dark rounded-full flex items-center justify-center text-sm shadow-sm" data-id="element-24">
                  {b.emoji}
                </div>
                <div className="text-pilates-lavender font-display font-bold text-lg mb-2" data-id="element-25">
                  {roman}.
                </div>
                <h3 className="font-display font-semibold text-pilates-blue-dark text-xl mb-2 leading-tight pr-10" data-id="element-26">
                  {b.title}
                </h3>
                <p className="text-pilates-slate text-base leading-relaxed" data-id="element-27">
                  {b.desc}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}